import { getBooleanSchema, getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const BranchSchema = Yup.object().shape({
  name: getStringSchema(50 ,'Branch name'),
  cmePayrollExportCode: getStringSchema(50, 'CME Payroll Export Code'),
  lrpPayrollExportCode: getStringSchema(50, 'LRP Payroll Export Code'),
  insAgencyId: getSelectSchema('Agency').notRequired(),
  eHarvestAliasUser: getStringSchema(255, 'eHarvest User').notRequired(),
  isMainOffice: getBooleanSchema("Main office"),
  isActive: getBooleanSchema("Active"),
});